import { render, staticRenderFns } from "./SubItemTable.vue?vue&type=template&id=e2945096&"
import script from "./SubItemTable.vue?vue&type=script&lang=ts&"
export * from "./SubItemTable.vue?vue&type=script&lang=ts&"
import style0 from "./SubItemTable.vue?vue&type=style&index=0&id=e2945096&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports